import React from 'react';
import { Divider, Typography } from 'antd';
import '../../../Styles/ResearchLabs.css';

const { Title } = Typography;

const facebookPage = 'https://www.facebook.com/sarl.ncgsa';
const facebookEmbed = `https://www.facebook.com/plugins/page.php?href=${encodeURIComponent(facebookPage)}&tabs=timeline&width=450&height=630&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true`;

const SocialFeed = () => (
  <section className="sarl-social-section">
    <div className="sarl-social-inner">
      <Title level={2} className="sarl-social-title">Social Feed</Title>
      <Divider className="ncgsa-divider" />

      <div className="sarl-facebook-frame-wrap">
        <iframe
          title="Space and Astrophysics Research Lab Facebook feed"
          src={facebookEmbed}
          className="sarl-facebook-frame"
          width="450"
          height="630"
          scrolling="no"
          frameBorder="0"
          allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
          loading="lazy"
        />
      </div>

      <a
        href={facebookPage}
        target="_blank"
        rel="noreferrer"
        className="sarl-facebook-fallback"
      >
        View Space and Astrophysics Research Lab on Facebook
      </a>
    </div>
  </section>
);

export default SocialFeed;
